import { tenantHttp, type HttpClient } from './core/http-client';
import type { AnalyticsOverview, LocationRating } from './models';

export class AnalyticsService {
  constructor(private readonly http: HttpClient) {}

  overview = (days: number) =>
    this.http.get<AnalyticsOverview>('/business/analytics', { query: { days } });

  locations = () => this.http.get<LocationRating[]>('/business/analytics/locations');
}

export const analyticsService = new AnalyticsService(tenantHttp);
